$(document).ready(function () {
  
  // GLOBAL VARS
  var currentUrl = window.location.pathname,
      windowHeight = $(window).height(),
      windowWidth = $(window).width(),
      page = $('html, body'),
      body = $('body'),
      header = $('#header');
      
  console.log('test scripts');
  
});